import React, {useState} from "react";
import './MoreActionsDropdown.css';

type Props = {

  options: [{
    label: string,
    onSelected: () => void,
  }]
}

export const MoreActionsDropdown = (props: Props) => {

  const [open, setOpen] = useState(false);

  return <div>
    <button 
        onClick={() => setOpen(!open)}
        onBlur={() => setOpen(false)}
        className={'ActionButton ActionButtonSecondary ActionButtonSmaller'}>...</button>

    {/* this div is an anchor for the relatively positioned overlay*/}
    <div style={{position: "relative"}}>
      <div className={'MoreActionsDropdown'} 
           
           style={{
             opacity: open ? 1 : 0,
             visibility: open ? 'visible' : 'hidden'}}>
        
        {props.options.map((option) => {
          return <div className={'MoreActionsDropdownItem'} onClick={() => {
            option.onSelected();
            setOpen(false);
          }}>{option.label}</div>
        })}
      </div>
    </div>
  </div>
}